// Conversion ratio from minor unit of currency, see https://en.wikipedia.org/wiki/ISO_4217#Minor_unit_fractions
export default {
	None: 1, // 1:1 (No minor unit) - Yen, Krona, etc.
	Two: 100, // 100:1 - Pound, Euro, Dollar, etc.
	Three: 1000 // 1000:1 - Dinar, etc.
};
